module.exports = __webpack_public_path__ + "static/media/no-image2.7bd0a501.jpg";